import axios from 'axios';

export const isLogoAvailable = async (companyUrl: string) => {
	try {
		await axios({
			url: `https://logo.clearbit.com/${companyUrl}`,
			method: 'get',
		});
		return {
			isError: false,
		};
	} catch (err) {
		console.log('err', err);
		return {
			isError: true,
		};
	}
};

export const generateCompanyLogoAvatarSrc = async (logo: string, url: string) => {
	if (logo?.length) return logo;
	if (!url) return '';

	const response = await isLogoAvailable(url);

	if (response.isError) return '/assets/company_logo.svg';
	return `https://logo.clearbit.com/${url}`;
};
